import { createSyncAction } from '@bimser/core';

import { IAddPanelPayload, AddPanelPayloadFactoryFromJS, AddPanelPayload } from '../../entities';
import * as ActionTypes from '../actionTypes';

export function addPanel(payload: IAddPanelPayload) {
	return createSyncAction(ActionTypes.ADD_PANEL, AddPanelPayloadFactoryFromJS(payload));
}
